



























































import { Component, Prop, Watch, Emit } from 'vue-property-decorator'
import { State } from 'vuex-class'
import { mixins } from 'vue-class-component'

import { Policy } from '@/modules/Policy/interfaces/policy'
import { Endorsement, IEndorsementChange } from '@/modules/Policy/interfaces/endorsement'
import { showErrors } from '@/utils/snack'
import { ApolloResponse } from '@/interfaces/apollo'
import { getPolicyEndorsements } from '@/modules/Policy/gql/endorsement.gql'
import { endorsementKeyMap } from '@/modules/Policy/helpers/endorsement'
import AppDialog from '@/components/AppDialog.vue'
import { dateTimeToDisplay, dateToDisplay } from '@/utils/dateTime'
import { RecordType } from '@/modules/RecordType/interfaces/record-type'
import { User } from '@/modules/User/interfaces/user'
import { Case } from '@/modules/Case/interfaces/case'
import EndorsementDialog from '@/modules/Policy/components/EndorsementDialog.vue'
import PolicyForm from '@/modules/Policy/components/PolicyForm.vue'
import PolicyDialog from '@/modules/Policy/scripts/policy-dialog'
import { policyStatus, billingType } from '@/modules/Policy/helpers/policy'
import { getRecordType } from '@/modules/RecordType/gql/record-type.gql'
import dollarFilter from '@/utils/dollarFilter'

@Component({
  components: {
    AppDialog,
    EndorsementDialog,
    PolicyForm
  }
})
export default class CaseDetailEndorsement extends mixins(PolicyDialog) {
@Prop({ type: Object as () => Case }) readonly caseInfo!: Case

  casePolicy: Policy | null = null
  casePolicyRecordType: RecordType | null = null

  endorsements: Endorsement[] = []

  changeContents: IEndorsementChange[] = []

  latestVersion: Endorsement | null = null

  noteDialog = {
    show: false,
    note: ''
  }

  dateTimeToDisplay = dateTimeToDisplay
  dateToDisplay = dateToDisplay
  policyStatus = policyStatus
  billingType = billingType

  R = this.$R

  endorsementDetailDialog: {
    show: boolean;
    endorsement: null | Endorsement;
    changeContent: null | IEndorsementChange;
  } = {
    show: false,
    endorsement: null,
    changeContent: null
  }

  @State(state => state.user.me) me!: User

  mounted () {
    if (!this.caseInfo) {
      return
    }
    this.casePolicy = this.caseInfo.targetPolicy
    this.parsePolicyTolatestVersion()
    this.getRecordType(this.caseInfo.targetPolicy.recordType.id)
  }

  @Watch('caseInfo', { deep: true })
  onCaseChanged (val: Case) {
    this.casePolicy = val.targetPolicy
    this.parsePolicyTolatestVersion()
    this.getRecordType(val.targetPolicy.recordType.id)
  }

  parsePolicyTolatestVersion () {
    const { casePolicy: policy } = this
    if (!policy) {
      return
    }

    this.latestVersion = {
      id: -1,
      policyId: policy.id,
      policyName: policy.policyName,
      status: policy.status,
      type: policy.type,
      effectiveDate: policy.effectiveDate,
      expirationDate: policy.expirationDate,
      originalInceptionDate: policy.originalInceptionDate,
      brokerFee: policy.brokerFee,
      agencyFee: policy.agencyFee,
      carrierPolicyFee: policy.carrierPolicyFee,
      inspectionFee: policy.inspectionFee,
      taxesFee: policy.taxesFee,
      stampingFee: policy.stampingFee,
      premium: policy.premium,
      policyNumber: policy.policyNumber,
      term: policy.term,
      closed: policy.closed,
      cancelDate: policy.cancelDate,
      createdAt: policy.createdAt,
      updatedAt: policy.updatedAt,
      additionalInfoStr: policy.additionalInfoStr,
      installmentPlan: policy.installmentPlan,
      billingType: policy.billingType,
      totalProjectedPremium: policy.totalProjectedPremium,
      totalProjectedCommission: policy.totalProjectedCommission,
      productCommissionOverride: policy.productCommissionOverride,
      federalEmployerIdNumber: policy.federalEmployerIdNumber,
      nonRenew: policy.nonRenew,
      shouldAutoCancel: policy.shouldAutoCancel,
      book: policy.book,
      account: policy.account,
      primaryContact: policy.primaryContact,
      source: policy.source,
      carrier: policy.carrier,
      carrierProduct: policy.carrierProduct,
      generalAgent: policy.generalAgent,
      recordType: policy.recordType,
      insuranceQuote: policy.insuranceQuote,
      note: '',
      createdBy: policy.createdBy
    }
  }

  parseAdditional (oldStr: string, newStr: string) {
    const { casePolicyRecordType: recordType } = this
    const newAdditionalInfo = JSON.parse(newStr)
    const old = JSON.parse(oldStr)
    const changeContents: any = {}
    const keyNameMap: any = {}

    if (!recordType) {
      return changeContents
    }

    for (const part of recordType.additionalInfo) {
      if (this.$R.contains(part.title, ['Base', 'Account Information', 'Carrier Information', 'Premium Information', 'Commission Information', 'Source Information'])) {
        continue
      }

      for (const item of part.items) {
        keyNameMap[item.keyName] = item.name
      }
    }

    for (let key of this.$R.keys(newAdditionalInfo)) {
      if (!keyNameMap[key]) {
        continue
      }

      if (!this.ifSameValue(old[key], newAdditionalInfo[key])) {
        changeContents[key] = {
          name: keyNameMap[key],
          from: old[key] || '-',
          to: newAdditionalInfo[key] || '-'
        }
      }
    }

    return changeContents
  }

  async getRecordType (recordTypeId: number) {
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getRecordType,
        variables: {
          recordTypeId: Number(recordTypeId)
        }
      })
      const recordType = result.data.getRecordType
      this.casePolicyRecordType = recordType

      this.getEndorsements()
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  async getEndorsements () {
    if (!this.casePolicy) {
      return
    }

    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getPolicyEndorsements,
        variables: {
          policyId: Number(this.casePolicy.id)
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      this.endorsements = result.data.getPolicyEndorsements
      this.onEndorsementsChanged()
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  onEndorsementsChanged () {
    const { latestVersion, endorsements } = this

    if (!latestVersion || !endorsements.length) return

    let oldVersion = endorsements[0]

    const changeContents = []

    for (let i = 1; i < endorsements.length; i++) {
      const item = endorsements[i]

      const changeContent = this.compareChanges(oldVersion, item)
      oldVersion = endorsements[i]
      changeContents.push(this.$R.filter((val: boolean) => val, changeContent))
    }

    changeContents.push(this.$R.filter(
      (val: boolean) => val,
      this.compareChanges(oldVersion, latestVersion)
    ))

    this.changeContents = changeContents
  }

  compareChanges (oldVersion: any, newVal: any) {
    const { date, fee, object, other, bool } = endorsementKeyMap
    const dateKeys = this.$R.keys(date)
    const feeKeys = this.$R.keys(fee)
    const objectKeys = this.$R.keys(object)
    const boolKeys = this.$R.keys(bool)
    const otherKeys = this.$R.keys(other)
    const keys: string[] = this.$R.keys(newVal)

    let changeContent: any = {}
    for (const key of keys) {
      switch (true) {
        case key === 'additionalInfoStr':
          changeContent = {
            ...changeContent,
            ...this.parseAdditional(oldVersion.additionalInfoStr, newVal[key])
          }
          break
        case this.$R.contains(key, objectKeys):
          if (!this.ifSameObject(oldVersion[key], newVal[key])) {
            changeContent[key] = {
              name: object[key],
              from: oldVersion[key] ? oldVersion[key].name : '-',
              to: newVal[key] ? newVal[key].name : '-'
            }
          }
          break
        case this.$R.contains(key, dateKeys):
          if (!this.ifSameDate(oldVersion[key], newVal[key])) {
            changeContent[key] = {
              name: date[key],
              from: oldVersion[key] ? dateToDisplay(oldVersion[key]) : '-',
              to: newVal[key] ? dateToDisplay(newVal[key]) : '-'
            }
          }
          break
        case this.$R.contains(key, feeKeys):
          if (!this.ifSameValue(oldVersion[key], newVal[key])) {
            changeContent[key] = {
              name: fee[key],
              from: oldVersion[key] ? dollarFilter(oldVersion[key]) : '$ 0',
              to: newVal[key] ? dollarFilter(newVal[key]) : '-'
            }
          }
          break
        case this.$R.contains(key, boolKeys):
          if (!this.ifSameValue(oldVersion[key], newVal[key])) {
            changeContent[key] = {
              name: bool[key],
              from: oldVersion[key] ? 'yes' : 'no',
              to: newVal[key] ? 'yes' : 'no'
            }
          }
          break
        case key === 'status':
          if (!this.ifSameValue(oldVersion[key], newVal[key])) {
            changeContent[key] = {
              name: 'Status',
              from: oldVersion[key] ? policyStatus[oldVersion[key]] : '-',
              to: newVal[key] ? policyStatus[newVal[key]] : '-'
            }
          }
          break
        case key === 'billingType':
          if (!this.ifSameValue(oldVersion[key], newVal[key])) {
            changeContent[key] = {
              name: 'Billing Type',
              from: oldVersion[key] ? policyStatus[oldVersion[key]] : '-',
              to: newVal[key] ? policyStatus[newVal[key]] : '-'
            }
          }
          break
        case this.$R.contains(key, otherKeys):
          if (!this.ifSameValue(oldVersion[key], newVal[key])) {
            changeContent[key] = {
              name: other[key],
              from: oldVersion[key] || '-',
              to: newVal[key] || '-'
            }
          }
          break
      }
    }

    return changeContent
  }

  ifSameValue (oldVal: string, newVal: string) {
    return (!oldVal && !newVal) || (newVal === oldVal)
  }

  ifSameObject<T extends { id: number, name: string }> (oldVal: T, newVal: T) {
    return (!oldVal && !newVal) ||
      (oldVal && newVal && oldVal.id === newVal.id)
  }

  ifSameDate (oldVal: string, newVal: string) {
    return (!oldVal && !newVal) ||
      (dateToDisplay(oldVal) === dateToDisplay(newVal))
  }

  clickEndorsementHandler (index: number) {
    if (index >= this.endorsements.length) {
      return
    }
    const endorsement = this.endorsements[index] || null
    const changeContent = this.changeContents[index - 1] || null
    this.endorsementDetailDialog = {
      show: true,
      endorsement,
      changeContent
    }
  }

  parseEndorsementNote (note: string) {
    return note ? note.split('\n') : []
  }

  onCancel () {
    this.endorsementDetailDialog = {
      show: false,
      endorsement: null,
      changeContent: null
    }
  }

  showNoteDialog () {
    this.noteDialog.show = true
  }

  updateNote (note: string) {
    this.noteDialog.note = note
    this.showPolicyEndorsementDialog()
  }

  @Emit('success')
  onSuccess () {
    this.endorsementDialog.show = false
    this.getEndorsements()
  }
}
